import { render, staticRenderFns } from "./combinList.vue?vue&type=template&id=547310e7&scoped=true&"
import script from "./combinList.vue?vue&type=script&lang=js&"
export * from "./combinList.vue?vue&type=script&lang=js&"
import style0 from "./combinList.vue?vue&type=style&index=0&id=547310e7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547310e7",
  null
  
)

export default component.exports